import { makeStyles, Skeleton, SkeletonItem as FRC_Skeleton, tokens } from '@fluentui/react-components';

const SkeletonItem = (props?: { className?: string }) => {
	const classes = useStyles();
 
	return (
		<Skeleton className={classes.skeletonRoot}>
			<FRC_Skeleton className={props?.className} />
		</Skeleton>
	);
};

export default function AuhtorizationSkeleton() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.content}>
				<SkeletonItem className={classes.stepBar} />
				<div className={classes.stepItemsRoot}>
					<SkeletonItem className={classes.stepItem} />
					<SkeletonItem className={classes.stepItem} />
					<SkeletonItem className={classes.stepItem} />
				</div>
				<div className={classes.paragraphRoot}>
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<SkeletonItem className={classes.paragraphItem} />
					<div className={classes.buttonRoot}>
						<SkeletonItem className={classes.buttonSkeleton} />
					</div>
				</div>
				<div style={{ marginTop: '32px', marginBottom: '24px' }}>
					<SkeletonItem className={classes.stepBar} />
				</div>
				<div className={classes.bottom}>
					<SkeletonItem className={classes.buttonSkeleton} />
				</div>
			</div>
		</div>
	);
}

export const useStyles = makeStyles({
	root: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		height: '100%',
		width: '100%',
		padding: '64px 0px',
		boxSizing: 'border-box',
	},
	content: {
		width: '100%',
		maxWidth: '600px',
		height: '100%',
		boxSizing: 'border-box',
	},
	skeletonRoot: {
		boxSizing: 'border-box',
	},
	stepBar: {
		height: '1px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	},
	stepItemsRoot: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '64px',
		bottom: '20px',
		position: 'relative',
	},
	stepItem: {
		height: '40px',
		width: '40px',
		borderRadius: '50%',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		},
	},
	paragraphRoot: {
		width: '100%',
		height: '100%',
		boxSizing: 'border-box',
	},
	paragraphItem: {
		marginTop: '4px',
		marginBottom: '4px',
		height: '24px',
		width: '100%',
		boxSizing: 'border-box',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	},
	bottom: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
		gap: '16px',
		marginTop: '32px',
		marginBottom: '32px',
	},
	buttonSkeleton: {
		height: '40px',
		width: '100px',
		borderRadius: '8px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	},
	buttonRoot: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '16px',
		marginTop: '32px',
		marginBottom: '32px',
	}
});